import React from "react";

class ColorPicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      onChange: props.onChange,
      colors: [
        "var(--data-delivers-green)",
        "white",
        "silver",
        "cyan",
        "#f4d35e",
        "#ef476f",
      ]
    }
  }

  render() {
    return (
      <React.Fragment>
        <div style={{display:"inline-block"}}>
          <div style={{display:"flex", paddingLeft:10}}>
            {this.state.colors.map((obj)=>{
              return(
                <div 
                  key={obj}
                  style={{backgroundColor:obj, boxShadow:"var(--box-shadow-stripe)", height: 30, width:30, borderRadius:5, marginRight:10}}
                  onClick={()=>{this.state.onChange(obj)}}
                />
              )
            })}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ColorPicker;



// WEBPACK FOOTER //
// ./src/views/ChatPage/chatPageComponents/sidebar/ChatPageSettings/SettingsCompoments/colorPicker.jsx